<template>
  <div style="height:100%" class="Parameter">
    <div class="manage">
      <div class="content">
        <div class="operation">
          <el-button type="primary" :round="false" size="small" icon="el-icon-plus" @click="dialogFormVisible = true">
            <span>添加</span>
          </el-button>
        </div>
        <div class="TypeList">
          <template>
            <el-table :border="true" :data="tableData" style="width: 100%">
              <el-table-column type="index"></el-table-column>
              <el-table-column prop="name" label="名称" width="240"></el-table-column>
              <el-table-column label="属性" width="240">
                <template slot-scope="scope">
                  <span v-for="(item, index) in scope.row.getSpec" :key="index">{{ item.spec }} | </span>
                </template>
              </el-table-column>
              <el-table-column label="操作">
                <template slot-scope="scope">
                  <el-button size="mini" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
                  <el-button size="mini" type="danger" @click="handleDelete(scope.$index, scope.row)">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
          </template>
        </div>
        <div class="Otherpage">
          <div class="changePage">
            <div @click="upPage" class="btnColor">
              <span>上一页</span>
            </div>
            <div>
              <span>{{ page }}</span>
            </div>
            <div @click="downPage" class="btnColor">
              <span>下一页</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 添加类型 -->
    <el-dialog title="添加类型" :visible.sync="dialogFormVisible">
      <el-form :model="form">
        <el-form-item label="类型名称" :label-width="formLabelWidth">
          <el-input v-model="form.name" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="添加属性" :label-width="formLabelWidth">
          <el-button @click="addAttr">
            <span>添加</span>
          </el-button>
        </el-form-item>
        <el-form-item :label-width="formLabelWidth">
          <el-table :data="selectedAttr" border v-if="selectedAttr.length > 0">
            <el-table-column property="name" label="属性名称" width=250></el-table-column>
            <!-- <el-table-column label="属性" width="200">
              <template slot-scope="scope">
                <span v-for="(item, index) in scope.row.SpecValue" :key="index">{{ item.value }} | </span>
              </template>
            </el-table-column> -->
            <el-table-column label="操作">
              <template slot-scope="scope">
                <el-button size="mini" @click="deleteAttr(scope.$index, scope.row)" type="primary">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancel">取 消</el-button>
        <el-button type="primary" @click="setJson">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="属性列表" :visible.sync="dialogTableVisible">
      <el-table :data="gridData" border height="300">
        <el-table-column property="name" label="名称" width="150"></el-table-column>
        <el-table-column label="属性" width="200">
          <template slot-scope="scope">
            <span v-for="(item, index) in scope.row.SpecValue" :key="index">{{ item.value }} | </span>
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button size="mini" @click="select(scope.$index, scope.row)" type="primary">选择</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="attrChangePage">
        <el-button size="small">上一页</el-button>
        <div class="num">
          <span>{{ attrpage }}</span>
        </div>
        <el-button size="small">下一页</el-button>
      </div>
    </el-dialog>
    <!-- 添加类型 -->
  </div>
</template>

<script>
import { TypeList, delType, AttrList, addType, getItemAttr, editType } from "@/api/mall";
import { mapGetters } from "vuex";
export default {
  computed: {
    ...mapGetters(["token", "app_id", "merch_id"])
  },
  components: {},
  data() {
    return {
      state: 0,
      attrpage: "1",
      idx: 1,
      value: "",
      input: "",
      page: "1",
      tableData: [],
      // 表格的高度等于盒子的高度减去
      gridData: [],
      dialogTableVisible: false,
      dialogFormVisible: false,
      form: {
        name: "",
        region: "",
        date1: "",
        date2: "",
        delivery: false,
        type: [],
        resource: "",
        desc: ""
      },
      formLabelWidth: "120px",
      selectedAttr: [],
      type_id: "",
      type_name: "",
      type_sort: "",
      type_value: "",
      id: ""
    };
  },
  methods: {
    cancel() {
      this.dialogFormVisible = false;
      this.form.name = "";
      this.selectedAttr = [];
    },
    handleEdit(index, row) {
      // 请求属性具体内容
      console.log(index, row);
      this.id = row.id;
      this.state = 1;
      this.form.name = row.name;
      // row.getSpec.forEach(element => {
      //   let data = {
      //     token: this.token,
      //     id: element.spec_id
      //   };
      //   getItemAttr(data).then(res => {
      //     console.log(res);
      //     this.selectedAttr.push(res.data);
      //     console.log(this.selectedAttr);
      //   });
      // });
      for (let i = 0; i < row.getSpec.length; i++) {
        const element = row.getSpec[i];
        new Promise((resolve, reject) => {
          let data = {
            token: this.token,
            id: element.spec_id
          };
          getItemAttr(data).then(res => {
            console.log(res);
            this.selectedAttr.push(res.data);
            console.log(this.selectedAttr);
            resolve(1);
          });
        }).then(resolve => {
          console.log(resolve);
          this.dialogFormVisible = true;
        });
      }
    },
    // 删除
    handleDelete(index, row) {
      console.log(index, row);
      let data = {
        token: this.token,
        id: row.id
      };
      delType(data).then(res => {
        console.log(res);
        this.$message({
          message: res.msg,
          type: "success"
        });
        this.getTypeList();
      });
    },
    // 属性列表
    getTypeList() {
      let data = {
        token: this.token,
        app_id: this.app_id,
        merch_id: this.merch_id,
        page: this.page
      };
      TypeList(data).then(res => {
        console.log(res);
        this.tableData = res.data;
      });
    },
    upPage() {
      // 上一页
      this.page--;
      if (this.page == 0) {
        this.page = 1;
        this.getTypeList();
      } else {
        this.getTypeList();
      }
    },
    downPage() {
      // 下
      this.page++;
      console.log(this.page);
      this.getTypeList();
      console.log(this.tableData.length);
      if (this.tableData.length == 0) {
        this.$message("请添加新品牌");
        this.page--;
        this.getTypeList();
      }
    },
    addAttr() {
      // 添加属性
      this.dialogTableVisible = true;
      this.state = 0;
      let data = {
        token: this.token,
        app_id: this.app_id,
        merch_id: this.merch_id,
        page: this.attrpage
      };
      AttrList(data).then(res => {
        console.log(res);
        this.gridData = res.data;
      });
    },
    select(index, row) {
      // 选择属性
      console.log(index, row);
      this.selectedAttr.push(row);
      this.dialogTableVisible = false;
    },
    deleteAttr(index, row) {
      // 删除选中的数据
      this.selectedAttr.splice(index, 1);
    },
    setJson() {
      // 确定添加类型
      if (this.form.name == "" || this.selectedAttr.length == 0) {
        this.$message({
          message: "请配置好数据",
          type: "warning"
        });
      } else {
        let type_id = [];
        for (let i = 0; i < this.selectedAttr.length; i++) {
          const element = this.selectedAttr[i];
          type_id.push(element.id);
        }
        this.type_id = JSON.stringify(type_id);
        if ( this.state == 0 ) {
          this.addType();
        } else {
          this.editType();
        }
      }
    },
    addType() {
      console.log(this.form);
      // 添加参数
      let data = {
        token: this.token,
        app_id: this.app_id,
        merch_id: this.merch_id,
        name: this.form.name,
        type_id: this.type_id
        // type_name: this.type_name,
        // type_sort: this.type_sort,
        // type_value: this.type_value
      };
      addType(data).then(res => {
        console.log(res);
        this.$message({
          message: res.msg,
          type: "success"
        });
        this.dialogFormVisible = false;
        this.getTypeList();
        this.form.name = "";
        this.selectedAttr = [];
      });
    },
    editType() {
      console.log(this.id);
      let data = {
        token: this.token,
        name: this.form.name,
        type_id: this.type_id,
        id: this.id
      };
      editType(data).then(res => {
        console.log(res);
        this.$message({
          message: res.msg,
          type: "success"
        });
        this.dialogFormVisible = false;
        this.getTypeList();
        this.form.name = "";
        this.selectedAttr = [];
      });
    }
  },
  mounted() {
    this.getTypeList();
  }
};
</script>

<style lang="scss" scoped>
el-table{
  height: calc(100% - 20px);
}
.manage {
  height: 100%;
  padding-left: 22px;
  padding-right: 72px;
  position: relative;
  .content {
    overflow: hidden;
    position: absolute;
    top: 0px;
    bottom: 26px;
    left: 22px;
    right: 70px;
    box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.1);
    border-radius: 3px;
    padding: 30px;
    .operation {
      height: 36px;
    }
    .TypeList {
      height: 100%;
      margin-top: 20px;
    }
    .Otherpage {
      height: 34px;
      width: 200px;
      position: absolute;
      bottom: 0;
      left: 30px;
      .changePage {
        height: 100%;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        div {
          height: 100%;
          width: 30%;
          text-align: center;
          line-height: 34px;
        }
        .btnColor {
          background: #b0b5bb30;
        }
      }
    }
  }
}

.attrChangePage {
  margin-top: 10px;
  height: 40px;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  .num {
    width: 30px;
    text-align: center;
    line-height: 40px;
    font-size: 20px;
  }
}
</style>

<style lang="scss">
.Parameter {
  .manage {
    .cell {
      text-align: left;
    }
  }
  .el-dialog__body {
    padding-top: 0;
  }
}
</style>
